export const COURSE_PLATFORM_SET_MODULES = 'COURSE_PLATFORM_SET_MODULES';
export const COURSE_PLATFORM_SET_LESSONS = 'COURSE_PLATFORM_SET_LESSONS';
export const COURSE_PLATFORM_SET_COMMENTS = 'COURSE_PLATFORM_SET_COMMENTS';
export const COURSE_PLATFORM_SET_LESSONS_FINISHED = 'COURSE_PLATFORM_SET_LESSONS_FINISHED';
// export const COURSE_PLATFORM_SET_SUPPORT = 'COURSE_PLATFORM_SET_SUPPORT';